import { createSelector } from "@ngrx/store";

import { IAppState } from "../state/app.state";
import { IUserState } from "@edp-store/state/user.state";

const userSelector = (state: IAppState) => state.user;

export const getUser = createSelector(
    userSelector,
    (state: IUserState) => state.user
);

export const getOnboarding = createSelector(
    userSelector,
    (state: IUserState) => state.onboarding
);

export const getLevelStatus = createSelector(
    userSelector,
    (state: IUserState) => state.levelStatus
);

export const getUserNotificationsList = createSelector(
    userSelector,
    (state: IUserState) => state.notifications.list
);

export const getUserNotificationsTotalNotViewed = createSelector(
    userSelector,
    (state: IUserState) => state.notifications.totalNotViewed
);

export const getUserNotificationsLastAPIError = createSelector(
    userSelector,
    (state: IUserState) => state.notifications.lastAPIError
);

export const isUserEdpE = createSelector(
    userSelector,
    (state: IUserState) => state.isUserEdpE
);

export const getPlanetAnniversary = createSelector(
    userSelector,
    (state: IUserState) => state.user.edpEYearChange
);

export const getShowCelebrationZs = createSelector(userSelector, (state: IUserState) => state.celebrationZs);

export const getLasCelebrationZs = createSelector(userSelector, (state: IUserState) => state.lastCelebrationZs);

export const getProfileStatus = createSelector(userSelector, (state: IUserState) => state.profileStatus);
export const getUserIsFirstLogin = createSelector(
    userSelector,
    (state: IUserState) => !state.user?.termsCond
);

export const getUserEarlyAccess = createSelector(userSelector, (state: IUserState) => state.user.earlyAccess);